import MetaObject from '@/docs-partials/api/schema/meta-object.mdx';
import * as React from 'react';
export default {
  MetaObject,
  React
};